// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1IRLD","productName":"Table_productName__2B8nr"};